import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { InputMaskModule } from 'primeng/inputmask';
import { PhoneCursorDirective } from '@App/common/directives';

interface Country {
  code: string;
  name: string;
  mask: string;
  flag: string;
  countryCode: string;
}

@Component({
  selector: 'app-country-input',
  templateUrl: './country-input.component.html',
  styleUrls: ['./country-input.component.scss'],
  imports: [SelectModule, FormsModule, InputMaskModule, PhoneCursorDirective],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountryInputComponent),
      multi: true
    }
  ]
})
export class CountryInputComponent implements OnInit {
  phoneNumber: string = '';
  countries: Country[] = [
    {
      code: 'US',
      name: 'USA',
      mask: '+1 (999) 999-9999',
      flag: 'us.svg',
      countryCode: '+1'
    },
    {
      code: 'CA',
      name: 'Canada',
      mask: '+1 (999) 999-9999',
      flag: 'ca.svg',
      countryCode: '+1'
    }
  ];
  @Input() disabled: boolean;
  @Input() readonly: boolean;
  @Input() required: boolean;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() containerStyleClass: string;
  @Input() inputStyleClass: any;
  @Input() flagDropdownStyle: string;
  @Input() isNewControlResponse: boolean;
  @Input() size: number;
  @Input() labelClass: string;
  @Input() floatLabel: boolean;
  selectedCountry: Country = this.countries[0];
  mask: string = this.countries[0].mask;
  value = { nationalNumber: '', countryIsoCode: '' };
  isFocused: boolean;

  constructor() {}

  ngOnInit() {
    this.mask = this.selectedCountry.mask;
  }

  onChange = (value: any) => {};

  onTouched = () => {};

  writeValue(value: any): void {
    if (!value) {
      this.phoneNumber = '';
      this.selectedCountry = this.countries[0];
      return;
    }

    this.selectedCountry =
      this.countries.find(
        (country) => country.code === value?.countryIsoCode
      ) || this.countries[0];

    this.value = value;
    this.phoneNumber = this.formatToMask(
      value.nationalNumber || '',
      this.selectedCountry.mask
    );
  }

  private formatToMask(nationalNumber: string, mask: string): string {
    let digits = nationalNumber.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) {
      digits = digits.slice(1);
    }
    let digitIndex = 0;
    let result = '';

    for (const maskChar of mask) {
      if (maskChar === '9') {
        if (digitIndex < digits.length) {
          result += digits[digitIndex++];
        } else {
          break;
        }
      } else {
        result += maskChar;
      }
    }

    return result;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  onCountryChange(event: any) {
    this.selectedCountry = event.value;
    this.mask = this.selectedCountry.mask;
    this.value = { ...this.value, countryIsoCode: event.value.code };
    this.onChange(this.value);
  }

  onInputChange(newValue: string) {
    if (!this.isNewControlResponse) {
      (this.value as unknown as string) = newValue;
      this.onChange(newValue);
      return;
    }

    const nationalNumber = this.nationalDigits(newValue);
    this.value = {
      nationalNumber,
      countryIsoCode: this.selectedCountry.code
    };
    this.onChange(this.value);
  }

  private nationalDigits(value: string): string {
    let digits = String(value ?? '').replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) {
      digits = digits.slice(1);
    }
    return digits;
  }

  onFocus(): void {
    this.isFocused = true;
  }

  onBlur(): void {
    this.isFocused = false;
  }
}
